function SvgCoffeeBeans(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 29" {...props}>
      <g fillRule="evenodd">
        <path d="M17.347 12.01a3.301 3.301 0 01-3.296 3.296H7.378a3.301 3.301 0 01-3.296-3.296V7.143h13.265v4.867zM2.04 21.43h17.347v-5.102H2.04v5.102zm0 6.122h17.347v-5.102H2.04v5.102zM24.49 0a.51.51 0 00-.51.51v2.551H12.755a.51.51 0 00-.51.51v2.551H3.06v5.888a4.303 4.303 0 001.53 3.296H.512a.51.51 0 000 1.02h.51v12.245h19.387V16.327h.51a.51.51 0 100-1.02h-4.081a4.3 4.3 0 001.53-3.297V6.122h-5.102v-2.04H24.49a.51.51 0 00.51-.51V.51a.51.51 0 00-.51-.51z" />
        <path d="M16.837 23.98H4.592a.51.51 0 100 1.02h12.245a.51.51 0 100-1.02" />
      </g>
    </svg>
  );
}

export default SvgCoffeeBeans;
